// Pure helper: map an incoming HTTPS Nearfluence URL (from a Universal Link /
// App Link tap) to an existing in-app SPA route. No side effects, no imports,
// so it stays trivially unit-testable and reuses the app's existing routes.
//
// Shared links can be either the OG-preview endpoints (/api/share/...) or the
// canonical public SPA routes. Both must land on the same in-app screen.
export function mapDeepLinkPath(rawUrl) {
  if (!rawUrl) return null;
  let path;
  try {
    const u = new URL(rawUrl);
    path = u.pathname + (u.search || "") + (u.hash || "");
  } catch {
    path = typeof rawUrl === "string" && rawUrl.startsWith("/") ? rawUrl : null;
  }
  if (!path) return null;

  // OG share endpoints -> public SPA routes (same screens the web redirect uses)
  path = path.replace(/^\/api\/share\/opportunity\//, "/opportunity/");
  path = path.replace(/^\/api\/share\/creator\//, "/creator/");

  // Any other /api/* link has no in-app screen to render — ignore it.
  if (path.startsWith("/api/")) return null;

  // Guard against protocol-relative or empty results.
  if (!path.startsWith("/")) return null;
  return path;
}
